<template>
    <img
        :src="$page.props.setting.baseUrl + '/img/logo-tumbas-500-165.png'"
        alt="logo aplikasi "
    />
</template>